<template>
	
	<v-dialog
	    v-model="visible"
		persistent
	    width="500"
		class="edit-dialog"
		ref="editDialog"
		eager
	>
		<v-card>
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text  class="mx-0 px-0 my-1">
                <div class="d-flex flex-row">
                    <div class="form-item form-item-width-2 my-1">
                        <label class="form-item-label mt-1 mr-1">选择门店:</label>				
                        <v-select
                            class="form-item-value"
                            v-model="editing.shopId"
                            :items="orgs"						
                            label=""
                            hide-details											
                            flat
                            item-text="shopName"
                            item-value='shopId'
                            outlined
                            dense		
                            clearable				
                        >
                        </v-select>
                    </div>
                </div>

                <div class="d-flex flex-row">
                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">收款台号:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0" 								
                            outlined
                            dense
                            placeholder=""							
                            v-model="editing.sktno"
                        >
                        </v-text-field>						
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">发票号码:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0" 								
                            outlined
                            dense
                            placeholder=""							
                            v-model="editing.fphm"
                        >
                        </v-text-field>						
                    </div>
                </div>
            </v-card-text>

            <v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  
			  <v-btn
				color="success"
				class="left-round"
				@click="handleSave"
			  >				
                <span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>
				加载
				
			  </v-btn>

              <v-btn
				color="blue-grey"
				class="right-round"
				@click="cancelClicked"
			  >
				
				取消
                <span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
			  </v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>

    import DragSupport from '../../../../../util/drag.js';
    import OrgApi from "../../../../../api/smp/org/DepartmentApi.js";
    import Permission from "../../../../../api/smp/auth/Permission.js";

    export default {
        name: 'Sm-Market-Printcoupon-TicketSelectDialog',
            components: {
                
            },
            data: () => ({          
                visible:false,
                
                title:"选择款台小票",
                orgs:[],

                editing:{
                    shopId:'',
                    shopName:'',
                    sktno:'',
                    fphm:'',
                },
            }),
            methods:{
                async errMsg(title,text){
                    await this.$dialog.error({
                        text: text,
                        title: title
                    });
                },
                setVisible(v){
                    this.visible=v;
                    let dialogEl = this.$refs.editDialog.$refs.dialog;
                    
                    if(this.visible==true)
                        DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
                    else
                        DragSupport.unbind(dialogEl);    
                },
                clear(){
                    this.editing={
                        shopId:'',
                        shopName:'',
                        sktno:'',
                        fphm:'',
                    };
                },
                cancelClicked(){
                    this.clear();
                    this.setVisible(false);
                },
                handleSave(){
                    if((!this.editing.shopId)||(this.editing.shopId=='')){
                        this.errMsg("错误","请选择门店");
                        return;
                    }

                    if((!this.editing.sktno)||(this.editing.sktno=='')){
                        this.errMsg("错误","请输入收款台号");
                        return;
                    }

                    if((!this.editing.fphm)||(this.editing.fphm=='')){
                        this.errMsg("错误","请输入发票号码");
                        return;
                    }

                    let me = this;
                    let params = {shopId: me.editing.shopId,sktno:me.editing.sktno,fphm:me.editing.fphm};

                    me.setVisible(false);
                    me.$emit("loadSaleCouponInfoRequested",params);
                },
                async loadOrgs(){
                    let me = this;
                    let queryShopPriviledgeResp = await Permission.queryShopPriviledge();
                    console.log("load shop previledge returned;");

                    console.log(queryShopPriviledgeResp);
                    
                    let data = queryShopPriviledgeResp.data;
                    if((!data)||(!(data.code))||(data.code!=200)){
                        let msg=data.msg;
                        msg = ((!msg)||(msg==''))?'获取门店权限情况失败':msg;
                        throw new Error(msg);
                        return;
                    }
                    if((!data.data)||(!data.data.shopPriviledges)){
                        throw new Error('获取门店权限情况失败(无会话数据)');
                        return;
                    }
                    
                    this.orgs = data.data.shopPriviledges;
                },
            },
            mounted(){
                this.loadOrgs();
            }
    }

</script>

<style scoped>

    .edit-dialog{
		border-radius: 4px;
	}
	.readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}

</style>
